<div class="d-flex flex-column">
  <div
    *ngIf="nuevoObjetoAux && nuevoObjetoAux.length > 0"
    id="title-itinerary"
    class="d-flex justify-content-center align-items-center"
    style="border-top-left-radius: 8px; border-top-right-radius: 8px"
    [ngStyle]="{
      'background-color': styleSidebar?.background_color_header
    }"
  >
    <p
      class="mb-0 font-weight-bold"
      style="font-family: 'Rubik', serif; font-size: 32px"
      [ngStyle]="{
        color: styleSidebar?.title
      }"
    >
      File
    </p>
  </div>

  <div
    *ngIf="nuevoObjetoAux && nuevoObjetoAux.length > 0"
    style="border-radius: 5px"
    [ngStyle]="{ 'background-color': styleSidebar?.background_color }"
  >
    <!-- Fin Título Itinerario -->
    <div
      *ngIf="modeView == 'RESULT' && origin !== 'MULTIDESTINATION'"
      [ngClass]="{ 'mb-5': modeView !== 'RESULT', 'mb-2': modeView !== 'RESULT' }"
    >
      <div *ngIf="nuevoObjetoAux != null"
            class="bg-darks m-0 p-0 pb-3"
            [ngStyle]="{ 'border': '2px solid ' + styleSidebar?.background_color,
                         'background-color': bodyStyle?.card_background_price
                       }"
      >
        <div *ngFor="let cityGroup of nuevoObjetoAux; let i = index" class="m-0 content-sidebar">
          <div
            class="d-flex flex-column justify-content-between m-0 p-0 "

            style="padding-bottom: 25px !important"
          >
            <div *ngFor="let dateGroup of cityGroup.items" class="title-cityName text-uppercase" style="width: 100%;">
              <div class="d-flex flex-row justify-content-between">

                <div class="d-flex flex-column mx-auto w-100" >
                  <ng-container *ngFor="let itemGroup of dateGroup.items">
                    <ng-container *ngIf="getCityGroup(cityGroup.city)">
                      <div class="d-flex flex-column pl-5 pb-2 pt-4 content-cityName"
                           [ngStyle]="{ 'background-color': styleSidebar?.background_color }">
                        <p *ngIf="itemGroup.items.length > 0"
                          class="mb-1 title-cityName"
                          style=" text-transform: capitalize; line-height: 1"
                           [ngStyle]="{
                                        color: styleSidebar?.title
                                      }">
                          {{ cityGroup.city }}
                        </p>
                         <div *ngIf="itemGroup.items.length > 0 && itemGroup.items[0]">
                          <p class="title-date" style="text-transform: capitalize; margin: auto 0"
                           [ngStyle]="{
                                        color: styleSidebar?.title
                                      }">

                            {{ itemGroup.items[0].arrivalDate | date : "dd - MMM" }}
                            <span style="text-transform: lowercase">a</span>
                            {{ itemGroup.items[0].departureDate | date : "dd - MMM" }}
                          </p>
                        </div>
                      </div>
                    </ng-container>

                  <div  *ngFor="let item of itemGroup.items; let lastIndex = last; index as i;" class="mb-2 pl-4 "
                  style="border-bottom-left-radius: 34px; border-bottom-right-radius: 34px"
                        [ngStyle]="{'border-bottom': i !== 0 && !lastIndex ? 'none' : '2px solid ' + styleSidebar?.background_color,
                                     'border-top-left-radius': i !== 0 ? 'none' : '34px'
                                   }"
                        style="padding-bottom: 25px !important; background-color: white; border-radius: 6px;">

                      <div class="d-flex justify-content-end align-items-center mb-3" >
                          <div class="d-flex flex-column justify-content-between mr-2 mt-2">
                            <span *ngIf="item.status_id === 1" class="status status-sidebar product-status-saved">{{ item.status }}</span>
                            <span *ngIf="item.status_id === 2" class="status status-sidebar product-status-reserved">{{ item.status }}</span>
                            <span *ngIf="item.status_id === 3" class="status status-sidebar product-status-locked">{{ item.status }}</span>
                            <span *ngIf="item.status_id === 4" class="status status-sidebar product-status-denied">{{ item.status }}</span>
                            <span *ngIf="item.status_id === 5" class="status status-sidebar product-status-cancelled">{{ item.status }}</span>
                            <span *ngIf="item.status_id === 6" class="status status-sidebar product-status-paid-agency">{{
                              item.status
                            }}</span>
                            <span *ngIf="item.status_id === 7" class="status status-sidebar product-status-paid-provider">{{
                              item.status
                            }}</span>
                            <span *ngIf="item.status_id === 8" class="status status-sidebar product-status-completed">{{ item.status }}</span>
                          </div>

                          <ng-container class="item-nav"
                                        *ngIf="(item?.status_id === 1 || item?.status_id === 4) && item?.status_id !== 5">
                              <div class="d-flex align-items-center py-1 px-1" style="border-bottom-left-radius: 8px;"
                                    [ngStyle]="{ 'border-bottom': '2px solid ' + styleSidebar?.background_color,
                                                 'border-left': '2px solid ' + styleSidebar?.background_color
                                                }">
                                <a *ngIf="deleteItem"
                                      class="item-button"
                                      (click)="removeItem(item, i)"
                                      title="delete">
                                  <i class="icon-delete" aria-hidden="true">&nbsp;&nbsp;</i>
                                </a>
                              </div>
                            </ng-container>
                      </div>

                    <!-- <ng-container *ngIf="item.categoryName === 'INSURANCE'">
                        <div class="d-flex flex-column">

                          <div class="d-flex flex-column" style="height: 120px;border-radius: 6px;background-color: white;">
                            <div class="flex-xl-grow-0 flex-grow-1 w-100 mx-auto" style="width: 100%; max-width: 235px;">
                              <img src="{{item?.images[0]}}"  alt="" style="width: 100%; height: auto; cursor: pointer; object-fit: cover">
                            </div>
                            <div class="d-flex mt-2">
                              <p class="title mb-0" style="width: 100%; text-align: center">{{item?.title}}</p>
                            </div>
                          </div>

                          <div class="d-flex mt-4 mb-3 pb-2 " style="border-bottom: 1px solid white;">
                            <div class="d-flex align-items-center ml-4" style="width:100%; gap: .25em;">
                              <img src="../../../../../assets/icons/itinerary/calendar_13937514.svg" class="mb-1" width="30px" height="30px" alt="">
                              <p class="mb-0" style="font-family: 'Rubik', serif;font-weight:600; font-size: 18px;text-transform: lowercase;">{{item?.trip?.days}} días</p>
                            </div>
                            <div class="d-flex align-items-center " style="width: 100%; gap: .30em;">
                              <img src="../../../assets/icons/search-result/persona.svg" width="26px" height="26px" alt="" />
                              <p class="mb-0"  style="font-family: 'Rubik', serif;font-weight:600; font-size: 18px;text-transform: lowercase;">{{item?.pax?.quantity}} pax</p>
                            </div>
                          </div>

                          <div class="d-flex flex-column pb-3" style="border-bottom: 1px solid white;">
                            <div class="d-flex mb-3  ml-4">
                              <div class="d-flex flex-column" style="width: 100%">
                                <p class="title mb-0" style="font-weight: 400;">Desde</p>
                                <p class="title mb-0">{{formatDate(item?.arrivalDate)}}</p>
                              </div>
                              <div class="d-flex flex-column" style="width: 100%">
                                <p class="title mb-0" style="font-weight: 400;">Hasta</p>
                                <p class="title mb-0">{{formatDate(item?.departureDate)}}</p>
                              </div>
                            </div>
                            <div class="d-flex  ml-4">
                              <div class="d-flex flex-column" style="width: 100%">
                                <p class="title mb-0" style="font-weight: 400;">Origen</p>
                                <p class="title mb-0">{{item?.form?.begin}}</p>
                              </div>
                              <div class="d-flex flex-column" style="width: 100%">
                                <p class="title mb-0" style="font-weight: 400;">Destino</p>
                                <p class="title mb-0">{{item?.form?.destination}}</p>
                              </div>
                            </div>
                          </div>

                          <div class="mt-3" *ngIf="item?.coverage?.coverageList && item?.coverage?.coverageList.length > 0">
                            <p class="title mb-0 ml-4">Incluye</p>
                            <div class="d-flex flex-column ml-4">
                              <ng-container *ngFor="let coverage of item?.coverage?.coverageList">
                                <p class="mb-0" style="font-family: 'Rubik', serif;font-weight:400; font-size: 12px;text-transform: lowercase;">
                                  {{coverage?.name}}&nbsp;<span style="text-transform: uppercase;">{{currencyAgency?.code}}</span> {{coverage?.coverage | currencyConverterPure:
                                                                                                                                      item?.pricing?.currency:
                                                                                                                                      currencyAgency?.code:
                                                                                                                                      currencies
                                                                                                                                    | number: '1.2-2'}}</p>
                              </ng-container>
                            </div>
                          </div>
                          <div class="mt-3" *ngIf="item?.addonsIncluded && item?.addonsIncluded.length > 0">
                            <p class="title mb-0 ml-4">Adicionales</p>
                            <div class="d-flex flex-column ml-4">
                              <ng-container *ngFor="let addon of item?.addonsIncluded">
                                <p class="mb-0" style="font-family: 'Rubik', serif;font-weight:400; font-size: 12px;text-transform: lowercase;">
                                  {{addon?.name}}&nbsp;<span style="text-transform: uppercase;">{{currencyAgency?.code}}</span> {{addon.cost | currencyConverterPure:
                                                                                                                                      item?.pricing?.currency:
                                                                                                                                      currencyAgency?.code:
                                                                                                                                      currencies
                                                                                                                                    | number: '1.2-2'}}</p>
                              </ng-container>
                            </div>
                          </div>
                          <div class=" py-3 mt-2 d-flex flex-column align-items-center justify-content-center" style="width: 100%; background-color: white; border-radius: 6px">
                                <div><p class="mb-0" style="font-family: 'Rubik', serif;font-weight: 400; font-size: 16px;text-transform: capitalize;">Tarifa total</p></div>

                          <div class="d-flex align-content-center">
                            <p

                            class="font-poppins m-0"
                            style="font-family: 'Rubik', serif; font-size: 22px; font-weight: 600; line-height: 1"
                            [ngStyle]="{ color: styleSidebar?.color }"
                          >

                            <span style=" font-size: 18px; font-weight: 500;">{{ currencyAgency?.code }} </span>
                              <span *ngIf="item.status_id !== 5">
                                 {{ getTotalPrice(item, 'insurance') | number: '1.2-2'}}
                              </span>
                              <span *ngIf="item.status_id === 5">
                                {{0 | number: '1.2-2'}}
                              </span>

                          </p>

                          <ng-container *ngIf="item.status_id !== 5">
                            <usb-tooltip-convert-amount
                                        [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                        [currencyProduct]="currencyAgency?.code"
                                        [valueProduct]="getTotalPrice(item, 'insurance')"
                                        >
                              </usb-tooltip-convert-amount>
                          </ng-container>

                          </div>
                                <div><p class="mb-0" style="font-family: 'Rubik', serif;font-weight: 400; font-size: 12px;text-transform: capitalize;">Impuestos incluidos</p></div>
                                <div class="d-flex" style="gap: .5em;">
                                  <p class="mb-0" style="font-family: 'Rubik', serif;font-weight: 400; font-size: 12px;text-transform: capitalize;"  [ngStyle]="{'color': styleSidebar?.background_color_header}">{{item.blickoins | number: '1.2-2'}} BKS</p>
                                  <p class="mb-0" style="font-family: 'Rubik', serif;font-weight: 400; font-size: 12px;text-transform: capitalize;"  [ngStyle]="{'color': styleSidebar?.background_color_header}">USD {{item.creditBlickoins | number: '1.2-2'}}</p>
                                </div>
                                <div></div>
                          </div>
                        </div>
                    </ng-container> -->
                      <!-- <div *ngIf="item.categoryName == 'INSURANCE'" class="flex-xl-grow-0 flex-grow-1 w-100 mb-2" style="width: 100%; max-width: 145px;">
                              <img src="{{item?.images[0]}}"  alt="" style="width: 100%; height: auto; object-fit: cover">
                      </div> -->

                    <div class="d-flex align-items-center justify-content-between" >



                      <div class="d-flex align-items-center" style="gap:.5em; width:100%;">
                        <div class="d-flex icon-item align-items-center justify-content-between" style="position: relative;">
                          <span
                            class="circle-icons"
                            [ngStyle]="{'background-color': bodyStyle?.card_background_price}"
                          >
                            <img
                                  *ngIf="item.categoryName == 'HOTELS'"
                                  width="25"
                                  src="../../../assets/icons/itinerary/bed-svgrepo-com.svg"
                                  alt="">

                              <img
                                *ngIf="item.categoryName == 'RENT-A-CAR'"
                                width="25"
                                src="../../../assets/img/app/categories-search-box/car-compact.svg"
                                alt=""
                              />

                              <img
                                *ngIf="item.categoryName == 'TRANSPORTS'"
                                width="25"
                                src=".../../../assets/icons/itinerary/school_15476203.svg"
                                alt=""
                              />

                              <img
                                *ngIf="item.categoryName == 'TOURS' && item.subCategoryId === 6"
                                width="25"
                                src="../../../assets/img/app/categories-search-box/road-map.svg"
                                alt=""
                              />
                              <img
                                *ngIf="item.categoryName == 'TOURS' && item.subCategoryId === 9"
                                width="25"
                                src="../../../assets/img/app/categories-search-box/combi-ticket.svg"
                                alt=""
                              />
                               <img
                                *ngIf="item.categoryName == 'INSURANCE'"
                                width="25"
                                src="../../../assets/img/app/categories-search-box/icon-seguro.svg"
                                alt=""
                              />
                            </span>
                          </div>

                        <div class="d-flex flex-column align-content-start ml-2 mr-3" style="text-transform: lowercase;">
                          <p *ngIf="item.categoryName == 'TOURS'"  class="title mb-0" [ngStyle]="{'color': styleSidebar?.color}">{{ stringUpperCase(item?.title) }}</p>
                          <p *ngIf="item.categoryName == 'HOTELS'" class="title mb-0" [ngStyle]="{'color': styleSidebar?.color}">{{ stringUpperCase(item?.title) }}</p>
                          <p *ngIf="item.categoryName == 'RENT-A-CAR'" style="font-weight: 400 !important;" class="title mb-0" [ngStyle]="{'color': styleSidebar?.color}">{{ stringUpperCase(item?.category) }}</p>
                          <p *ngIf="item.categoryName == 'RENT-A-CAR'" class="title mb-0" [ngStyle]="{'color': styleSidebar?.color}">{{ stringUpperCase(item?.title) }}</p>
                          <p *ngIf="item.categoryName == 'TRANSPORTS'" class="title mb-2 text-uppercase" [ngStyle]="{'color': styleSidebar?.color}">{{ item.firstWay ? getTypeWay(item?.firstWay) : getTypeWay(item?.noCloneFirstWay)}}</p>
                          <p *ngIf="item.categoryName == 'TRANSPORTS'" class="title mb-0 text-uppercase" [ngStyle]="{'color': styleSidebar?.color}">{{ stringUpperCase(item?.title) }}</p>
                          <p *ngIf="item.categoryName == 'INSURANCE'" style="font-weight: 400 !important;" class="title mb-0" [ngStyle]="{'color': styleSidebar?.color}">Asistencia</p>
                          <p *ngIf="item.categoryName == 'INSURANCE'" class="title mb-0 text-uppercase" [ngStyle]="{'color': styleSidebar?.color}">{{ stringUpperCase(item?.title) }}</p>

                          <div class="d-flex align-items-0">
                              <p *ngIf="item?.categoryName == 'HOTELS' || item?.categoryName == 'TOURS'"
                               class="regime mb-0" style="width: fit-content; text-transform: capitalize;"
                               [ngStyle]="{'color': item.rateClassId == 'R' ? '#02d498' : '#d60159'}">{{item.rateClassId == "R" ? 'Reembolsable' : 'No Reembolsable'}}
                              </p>
                              <span *ngIf="item?.categoryName === 'HOTELS' || item?.categoryName == 'TOURS'">
                                <span *ngIf="item.rateClassId == 'R'">
                                 <span *ngIf="item?.categoryName === 'HOTELS'">
                                   <div class="info-tool d-flex flex-column" *ngIf="getCancellationPolicies('hotels', item)">
                                    <i class="fas fa-exclamation-circle"
                                        aria-hidden="true"
                                        style="font-size: 13px;"
                                        [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"></i>
                                     <span class="tooltip-info shadow-md">
                                         <table>
                                           <tr style="border-bottom: 1px solid #ececec">
                                             <th style="text-align: center">
                                               <p >Hasta</p>
                                             </th>
                                            <th style="text-align: center">
                                               <p>Tarifa</p>
                                             </th>
                                           </tr>
                                           <ng-container *ngFor="let cancellation of item?.room?.cancellationPolicy">
                                             <tr>
                                               <td style="text-align: start">
                                                 <p class="mb-2" style="font-family: 'Rubik', serif;color: black;">{{ cancellation.from | date: 'dd/MM/yyyy' }}</p>
                                               </td>
                                               <td>
                                                 <p class="mb-2" style="font-family: 'Rubik', serif;color: black;text-transform: uppercase;">
                                                  <!-- {{cancellation.currency}} {{ cancellation.amount | number: '1.2-2' }} -->
                                                  {{currencyAgency?.code}}
                                                 {{ cancellation.amount
                                                    | currencyConverterPure:
                                                      cancellation.currency:
                                                      currencyAgency?.code:
                                                      currencies
                                                    | number: '1.2-2'}}
                                                </p>
                                               </td>
                                             </tr>
                                           </ng-container>
                                         </table>
                                       </span>
                                   </div>
                                 </span>
                                 <span *ngIf="item?.categoryName === 'TOURS'">
                                   <div class="info-tool d-flex flex-column" *ngIf="getCancellationPolicies('tours', item)">
                                    <i class="fas fa-exclamation-circle"
                                        aria-hidden="true"
                                        style="font-size: 13px;"
                                        [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"></i>
                                     <span class="tooltip-info shadow-md">
                                         <table>
                                           <tr style="border-bottom: 1px solid #ececec">
                                             <th style="text-align: center">
                                               <p >Hasta</p>
                                             </th>
                                            <th style="text-align: center">
                                               <p>Tarifa</p>
                                             </th>
                                           </tr>
                                           <ng-container *ngFor="let cancellation of item?.experience.cancellation_policy; let i = index;">
                                             <tr>
                                               <td style="text-align: start">
                                                 <p class="mb-2" style="font-family: 'Rubik', serif;color: black;">{{ cancellation.dateFrom | date: 'dd/MM/yyyy' }}</p>
                                               </td>
                                               <td>
                                                 <p class="mb-2" style="font-family: 'Rubik', serif;color: black;text-transform: uppercase;">
                                                  {{currencyAgency?.code}}
                                                 {{ item?.cancellationPolicies?.cancellationPolicies[i].amount
                                                    | currencyConverterPure:
                                                      item?.currency:
                                                      currencyAgency?.code:
                                                      currencies
                                                    | number: '1.2-2'}}
                                                </p>
                                               </td>
                                             </tr>
                                           </ng-container>
                                         </table>
                                       </span>
                                   </div>
                                 </span>

                               </span>
                               </span>
                               <span *ngIf="item.categoryName == 'TRANSPORTS'">
                                <div  class="d-flex align-items-center">
                                      <p
                                        class="regime mb-0" style="width: fit-content; text-transform: capitalize;"
                                        [ngStyle]="{'color': item.pricing?.rateClass == 'R' ? '#02d498' : '#d60159'}">{{item.pricing?.rateClass == "R" ? 'Reembolsable' : 'No Reembolsable'}}
                                      </p>
                                      <span *ngIf="item?.categoryName === 'TRANSPORTS' && item.pricing?.rateClass == 'R'">
                                            <div class="info-tool d-flex flex-column" *ngIf="getCancellationPolicies('transports', item)">
                                              <i class="fas fa-exclamation-circle"
                                                  aria-hidden="true"
                                                  style="font-size: 13px;"
                                                  [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"></i>
                                              <span class="tooltip-info shadow-md">
                                            <table>
                                              <tr style="border-bottom: 1px solid #ececec">
                                                <th style="text-align: center">
                                                  <p >Hasta</p>
                                                </th>
                                                <th style="text-align: center">
                                                  <p>Tarifa</p>
                                                </th>
                                              </tr>
                                              <ng-container *ngFor="let cancellation of item?.cancellationPolicies">
                                                <tr>
                                                  <td style="text-align: start">
                                                    <p class="mb-2" style="font-family: 'Rubik', serif;color: black;">{{ cancellation.from | date: 'dd/MM/yyyy' }}</p>
                                                  </td>
                                                  <td>
                                                    <p class="mb-2" style="font-family: 'Rubik', serif;color: black;text-transform: uppercase;">
                                                      <!-- {{cancellation.currency}} {{ cancellation.amount | number: '1.2-2' }} -->
                                                      {{currencyAgency?.code}}
                                                    {{ cancellation.amount
                                                        | currencyConverterPure:
                                                          item?.currency:
                                                          currencyAgency?.code:
                                                          currencies
                                                        | number: '1.2-2'}}
                                                    </p>
                                                  </td>
                                                </tr>
                                              </ng-container>
                                            </table>
                                          </span>
                                      </div>
                                   </span>
                                  </div>
                               </span>
                               <span class="d-flex flex-row" *ngIf="item.categoryName == 'RENT-A-CAR' || item.categoryName == 'INSURANCE'">
                                 <p *ngIf="item?.categoryName == 'RENT-A-CAR' || item.categoryName == 'INSURANCE'"
                               class="regime mb-0" style="width: fit-content; text-transform: capitalize;"
                               [ngStyle]="{'color': item.rateClass == 'R' ? '#02d498' : '#d60159'}">{{item.rateClass == "R" ? 'Reembolsable' : 'No Reembolsable'}}
                              </p>
                              <span *ngIf="(item?.categoryName === 'RENT-A-CAR' || item.categoryName == 'INSURANCE') && item.rateClass == 'R'">
                                            <div class="info-tool d-flex flex-column" >
                                              <i class="fas fa-exclamation-circle"
                                                  aria-hidden="true"
                                                  style="font-size: 13px;"
                                                  [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"></i>
                                              <span class="tooltip-info shadow-md">
                                            <table>
                                              <tr style="border-bottom: 1px solid #ececec">
                                                <th style="text-align: center">
                                                  <p >Hasta</p>
                                                </th>
                                                <th style="text-align: center">
                                                  <p>Tarifa</p>
                                                </th>
                                              </tr>
                                              <ng-container *ngFor="let cancellation of item?.cancellationPolicies">
                                                <tr>
                                                  <td style="text-align: start">
                                                    <p class="mb-2" style="font-family: 'Rubik', serif;color: black;">{{ cancellation.from | date: 'dd/MM/yyyy' }}</p>
                                                  </td>
                                                  <td>
                                                    <p class="mb-2" style="font-family: 'Rubik', serif;color: black;text-transform: uppercase;">
                                                      <!-- {{cancellation.currency}} {{ cancellation.amount | number: '1.2-2' }} -->
                                                      {{currencyAgency?.code}}
                                                    {{ cancellation.amount
                                                        | currencyConverterPure:
                                                          item?.currency:
                                                          currencyAgency?.code:
                                                          currencies
                                                        | number: '1.2-2'}}
                                                    </p>
                                                  </td>
                                                </tr>
                                              </ng-container>
                                            </table>


                                          </span>
                                      </div>
                                   </span>

                               </span>

                          </div>
                      </div>

                      </div>

                  </div>


                   <div class="d-flex flex-column align-content-start mr-3" style="text-transform: lowercase;">


                            <button
                                  (click)="toggleExpand(item.id)"
                                      [attr.aria-expanded]="isExpanded(item.id)"
                                      class="expand-btn d-flex py-1 mt-2 px-2 justify-content-between align-items-center"
                                      [ngStyle]="{
                                          'border': 'none',
                                          'cursor': 'pointer',
                                          'background-color': styleSidebar?.background_color || 'transparent'
                                      }"
                            >
                                <p class="mb-0 mr-1" style="font-family: 'Rubik', serif; font-size: 12px;"
                                 [ngStyle]="{
                                              color: styleSidebar?.title
                                            }">
                                    {{ isExpanded(item.id) ? 'Ver menos' : 'Ver detalle' }}
                                </p>
                                <i
                                    class="fas fa-chevron-down"
                                    [ngClass]="{'rotated': isExpanded(item.id)}"
                                    [ngStyle]="{'color': styleSidebar?.color}"
                                    style="transition: transform 0.3s ease; font-size: 12px;"
                                ></i>
                            </button>


                      <div
                              class="collapsible-content p-2"
                              [class.expanded]="isExpanded(item.id)"
                              [ngStyle]="{'margin-bottom': isExpanded(item.id) ? '25px' : '0'}"
                              style="overflow: hidden; transition: max-height 0.3s ease, opacity 0.2s ease; background-color: white; border-radius: 6px;"
                            >

                            <!-- HOTEL -->
                            <ng-container *ngIf="item.categoryName === 'HOTELS'">
                              <usb-item-hotel
                                [item]="item"
                                [styleSidebar]="styleSidebar"
                                [currencyAgency]="currencyAgency"
                                [currencies]="currencies"
                              ></usb-item-hotel>
                            </ng-container>

                            <!-- RENT-A-CAR -->
                            <ng-container *ngIf="item.categoryName === 'RENT-A-CAR'">
                              <usb-item-rentacar-sidebar
                                [item]="item"
                                [styleSidebar]="styleSidebar"
                                [currencyAgency]="currencyAgency"
                                [currencies]="currencies"
                              ></usb-item-rentacar-sidebar>
                            </ng-container>

                            <!-- TOURS -->
                            <ng-container *ngIf="item.categoryName === 'TOURS'">
                              <usb-item-tours
                                [item]="item"
                                [styleSidebar]="styleSidebar"
                                [currencyAgency]="currencyAgency"
                                [currencies]="currencies"
                              ></usb-item-tours>
                            </ng-container>

                            <ng-container *ngIf="item.categoryName == 'TRANSPORTS'">
                              <usb-item-transports
                                [item]="item"
                                [styleSidebar]="styleSidebar"
                                [currencyAgency]="currencyAgency"
                                [currencies]="currencies"
                              ></usb-item-transports>
                            </ng-container>

                            <ng-container *ngIf="item.categoryName == 'INSURANCE'">
                              <usb-item-insurance
                                [item]="item"
                                [styleSidebar]="styleSidebar"
                                [currencyAgency]="currencyAgency"
                                [currencies]="currencies"
                              ></usb-item-insurance>
                            </ng-container>

                          <div class="wrapper-transfer icon-item mt-3" *ngIf="item.categoryName == 'TOURS' && item?.subCategoryId === 6 && item?.experience?.addonsIncluded.length >= 1">
                          <span class="title-cityName justify-content-between" style="font-family: 'Rubik', serif; font-size: 14px;">Adicionales</span>
                          <div class="d-flex flex-row justify-content-between w-100" *ngFor="let optionalsTours of item.experience.addonsIncluded; let i = index">
                            <span class="text-start" style="font-family: 'Rubik', serif; font-size: 14px;">
                              {{optionalsTours.description }}
                              {{ currencyAgency?.code}}
                              {{optionalsTours.totalPriceProf | currencyConverterPure: item?.currency: currencyAgency?.code: currencies | number: '1.2-2'}}
                            </span>
                          </div>
                        </div>
                      </div>
                   </div>
                      <div class="title-cityName text-uppercase " style="width: 100%;"
                     >
                        <div
                          *ngIf="item?.categoryName == 'HOTELS' ||
                                 item?.categoryName == 'TRANSPORTS' ||
                                 item?.categoryName == 'TOURS' ||
                                 item?.categoryName == 'RENT-A-CAR' ||
                                 item?.categoryName == 'INSURANCE'"
                          style="text-align: start"
                        >
                          <div class="mr-3 py-3"  [ngStyle]="{'border-top': '1.5px solid ' + styleSidebar?.background_color,
                                  'border-bottom': '1.5px solid ' + styleSidebar?.background_color}">
                            <p
                              class="font-poppins m-0 mb-1"
                              style="font-family: 'Rubik', serif; font-size: 14px; font-weight: 600; line-height: 1"
                              [ngStyle]="{ color: styleSidebar?.color }"
                            >
                              TARIFA TOTAL
                            </p>
                          <div  *ngIf="item?.categoryName == 'HOTELS'" class="d-flex justify-content-start">
                              <p

                                class="font-poppins m-0"
                                style="font-family: 'Rubik', serif; font-size: 22px; font-weight: 600; line-height: 1"
                              >
                                <!-- {{ item.currency }} {{ item.optionNightsNetTotalProf | number : "1.2-2" }} -->
                                {{ currencyAgency?.code }}
                                  <span *ngIf="item.status_id !== 5">
                                     {{ getTotalPrice(item, 'hotels') | number: '1.2-2'}}
                                  </span>
                                  <span *ngIf="item.status_id === 5">
                                    {{0 | number: '1.2-2'}}
                                  </span>

                              </p>

                              <ng-container *ngIf="item.status_id !== 5">
                                <usb-tooltip-convert-amount
                                            [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                            [currencyProduct]="currencyAgency?.code"
                                            [valueProduct]="getTotalPrice(item, 'hotels')"
                                            >
                                  </usb-tooltip-convert-amount>
                              </ng-container>
                            </div>

                            <div  *ngIf="item?.categoryName == 'HOTELS' && item.status_id !== 5 && item.currency !== currencyAgency?.code">
                                  <div class="d-flex justify-content-start">
                                    <p class="mb-0"
                                    style="font-family: 'Rubik', serif; font-size: 12px; font-weight: 600;"
                                    [ngStyle]="{ color: styleSidebar?.color }"
                                    >{{item.currency}} {{ (item.optionNightsNetTotalProf + (item.room?.pricing?.taxesExcluded || 0)) | number:'1.2-2'}}</p>
                                                    <div class="info-tool d-flex flex-column position-relative">
                                      <i class="fas fa-exclamation-circle"
                                          aria-hidden="true"
                                          style="font-size: 13px;"
                                          [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"></i>
                                      <span class="tooltip-info shadow-md">
                                        <div class="d-flex justify-content-center align-items-center px-2 py-1">
                                          <p class="mb-0" style="font-size: 14px;color: black;">{{userService.messageProviderAmount}}</p>
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                            </div>

                            <div  *ngIf="item?.categoryName == 'TRANSPORTS'" class="d-flex justify-content-start">
                              <p

                                class="font-poppins m-0"
                                style="font-family: 'Rubik', serif; font-size: 22px; font-weight: 600; line-height: 1"
                              >

                                      {{currencyAgency.code }}
                                      <span *ngIf="item.status_id !== 5">
                                        {{  getTotalPrice(item, 'transports') | number: '1.2-2' }}
                                      </span>
                                      <span *ngIf="item.status_id === 5">
                                        {{0 | number: '1.2-2'}}
                                      </span>
                              </p>
                               <ng-container *ngIf="item.status_id !== 5">
                                <usb-tooltip-convert-amount
                                            [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                            [currencyProduct]="currencyAgency?.code"
                                            [valueProduct]="getTotalPrice(item, 'transports')"
                                            >
                                  </usb-tooltip-convert-amount>
                              </ng-container>
                            </div>

                            <div  *ngIf="item?.categoryName == 'TRANSPORTS' && item.currency !== currencyAgency?.code && item.status_id !== 5">
                                  <div class="d-flex justify-content-start">
                                    <p class="mb-0"
                                    style="font-family: 'Rubik', serif; font-size: 12px; font-weight: 600;"
                                    [ngStyle]="{ color: styleSidebar?.color }"
                                    >{{item.currency}} {{(item.netPriceBookingWithIncluded && item.netPriceBookingWithIncluded > item.totalPriceProf
                                    ? item.netPriceBookingWithIncluded
                                    : item.totalPriceProf) | number:'1.2-2'}}</p>
                                                    <div class="info-tool d-flex flex-column position-relative">
                                       <i class="fas fa-exclamation-circle"
                                          aria-hidden="true"
                                          style="font-size: 15px;"
                                          [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"></i>
                                      <span class="tooltip-info shadow-md">
                                        <div class="d-flex justify-content-center align-items-center px-2 py-1">
                                          <p class="mb-0" style="font-size: 14px;color: black;">{{userService.messageProviderAmount}}</p>
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                            <div  *ngIf="item?.categoryName == 'TOURS'" class="d-flex justify-content-start">
                              <p

                                class="font-poppins m-0"
                                style="font-family: 'Rubik', serif; font-size: 22px; font-weight: 600; line-height: 1"
                              >


                                      {{currencyAgency.code }}
                                      <span *ngIf="item.status_id !== 5">
                                        {{  getTotalPrice(item, 'tours') | number: '1.2-2'}}
                                      </span>
                                      <span *ngIf="item.status_id === 5">
                                        {{0 | number: '1.2-2'}}
                                      </span>
                              </p>

                              <ng-container *ngIf="item.status_id !== 5">
                                <usb-tooltip-convert-amount
                                            [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                            [currencyProduct]="currencyAgency?.code"
                                            [valueProduct]="getTotalPrice(item, 'tours')"
                                            >
                                  </usb-tooltip-convert-amount>
                              </ng-container>


                            </div>

                            <div  *ngIf="item?.categoryName == 'TOURS' && item.currency !== currencyAgency?.code && item.status_id !== 5" >
                                  <p class="mb-0"
                                    style="font-family: 'Rubik', serif; font-size: 12px; font-weight: 600;"
                                    [ngStyle]="{ color: styleSidebar?.color }"
                              >
                              {{ item.currency }} {{ item.totalPriceProf | number : "1.2-2" }}
                            </p>
                              <p
                                class="font-poppins m-0"
                                style="
                                  font-family: 'Rubik', serif;
                                  font-size: 12px;
                                  font-weight: 600;
                                  line-height: 1;
                                  text-transform: capitalize;
                                "
                                [ngStyle]="{ color: styleSidebar?.color }"
                                >
                                Imp. incluidos
                              </p>
                            </div>

                            <div  *ngIf="item?.categoryName == 'RENT-A-CAR'" class="d-flex justify-content-start">
                              <p

                                class="font-poppins m-0"
                                style="font-family: 'Rubik', serif; font-size: 22px; font-weight: 600; line-height: 1"
                              >
                                <!-- {{ item.currency }} {{ item.optionNightsNetTotalProf | number : "1.2-2" }} -->
                                {{ currencyAgency?.code }}
                                  <span *ngIf="item.status_id !== 5">
                                     {{ getTotalPrice(item, 'RENT-A-CAR') | number: '1.2-2'}}
                                  </span>
                                  <span *ngIf="item.status_id === 5">
                                    {{0 | number: '1.2-2'}}
                                  </span>

                              </p>

                              <ng-container *ngIf="item.status_id !== 5">
                                <usb-tooltip-convert-amount
                                            [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                            [currencyProduct]="currencyAgency?.code"
                                            [valueProduct]="getTotalPrice(item, 'RENT-A-CAR')"
                                            >
                                  </usb-tooltip-convert-amount>
                              </ng-container>
                            </div>
                            <div  *ngIf="item?.categoryName == 'INSURANCE'" class="d-flex justify-content-start">

                                <p
                                    class="font-poppins m-0"
                                    style="font-family: 'Rubik', serif; font-size: 22px; font-weight: 600; line-height: 1"
                                  >

                                    {{ currencyAgency?.code }}
                                      <span *ngIf="item.status_id !== 5">
                                        {{ getTotalPrice(item, 'insurance') | number: '1.2-2'}}
                                      </span>
                                      <span *ngIf="item.status_id === 5">
                                        {{0 | number: '1.2-2'}}
                                      </span>

                                  </p>

                                  <ng-container *ngIf="item.status_id !== 5">
                                    <usb-tooltip-convert-amount
                                                [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                                [currencyProduct]="currencyAgency?.code"
                                                [valueProduct]="getTotalPrice(item, 'insurance')"
                                                >
                                      </usb-tooltip-convert-amount>
                                  </ng-container>

                            </div>

                             <div  *ngIf="item?.categoryName == 'INSURANCE' && item.currency !== currencyAgency?.code && item.status_id !== 5 ">
                                    <p class="mb-0"
                                    style="font-family: 'Rubik', serif; font-size: 12px; font-weight: 600;"
                                    [ngStyle]="{ color: styleSidebar?.color }"
                                    >{{item.currency}} {{ item.netPriceAgent | number:'1.2-2'}}</p>
                                                    <div class="info-tool d-flex flex-column position-relative">
                                      <i class="fas fa-exclamation-circle"
                                          aria-hidden="true"
                                          style="font-size: 13px;"
                                          [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"></i>
                                      <span class="tooltip-info shadow-md">
                                        <div class="d-flex justify-content-center align-items-center px-2 py-1">
                                          <p class="mb-0" style="font-size: 14px;color: black;">{{userService.messageProviderAmount}}</p>
                                        </div>
                                      </span>
                                    </div>
                             </div>



                          </div>

                          <div *ngIf="item.status_id !== 5" class="d-flex flex-column mt-1 mr-3">
                            <button
                                  (click)="toggleExpandBlickoins(item.id)"
                                      [attr.aria-expanded]="isExpandedBlickoins(item.id)"
                                      class="expand-btn d-flex py-1 mt-2 px-2 justify-content-between align-items-center"
                                      [ngStyle]="{
                                          'border': 'none',
                                          'cursor': 'pointer',
                                          'background-color': styleSidebar?.background_color || 'transparent'
                                      }"
                            >
                                <p class="mb-0 mr-1" style="font-family: 'Rubik', serif; font-size: 12px;"
                                 [ngStyle]="{
                                              color: styleSidebar?.title
                                            }">
                                    {{ isExpanded(item.id) ? 'Ocultar blickoins' : 'Ver blickoins' }}
                                </p>
                                <i
                                    class="fas fa-chevron-down"
                                    [ngClass]="{'rotated': isExpandedBlickoins(item.id)}"
                                    [ngStyle]="{'color': styleSidebar?.color}"
                                    style="transition: transform 0.3s ease; font-size: 12px;"
                                ></i>
                            </button>

                            <div
                             class="collapsible-content p-2 d-flex align-items-middle"
                              [class.expanded]="isExpandedBlickoins(item.id)"
                              [ngStyle]="{'margin-bottom': isExpandedBlickoins(item.id) ? '25px' : '0'}"
                              style="overflow: hidden; transition: max-height 0.3s ease, opacity 0.2s ease; background-color: white; border-radius: 6px;">
                              <img
                                src="../../../assets/img/app/little-icons/badge-bks.png"
                                class="mr-1"
                                style="width: 25px; height: 30px; margin-top: 1px"
                                alt=""
                              />
                              <span class="font-point d-flex align-items-center" style="font-family: 'Rubik', serif; font-size: 16px !important;">
                                {{ item.status_id !== 5 ? item.profility.blickoins : 0.00 }}&nbsp;BKS
                              </span>
                              <span class="font-point d-flex align-items-center">
                                <p class="p-night m-0 pl-2" style="font-family: 'Rubik', serif; font-size: 16px;">
                                  USD&nbsp;{{ item.status_id !== 5 ? item.profility.creditBlickoins : 0.00 }}
                                </p>
                              </span>
                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MULTIDESTINATION -->
    <div class="mb-5" *ngIf="modeView == 'RESULT' && origin === 'MULTIDESTINATION' && userService.multidestination">
      <!-- SOY MULTIDESTINATION -->
      <div *ngFor="let destiny of userService.multidestination; let i = index">
        <div *ngIf="destiny !== undefined">
          <div class="col-12 bg-darks mb-2" id="info-hotels">
            <div class="row px-2 mb-2">
              <div class="col-12 name-destination bg-green py-1">
                <div class="row">
                  <div class="col-12">
                    <span class="font-poppins f-18 font-dark align-middle text-uppercase text-left" style="font-weight: 500 !important">
                      {{ destiny?.city }}
                    </span>
                    <span class="font-poppins f-14 text-white align-middle date-itinerary" id="date-start">
                      {{ destiny?.dd }} a {{ destiny?.ddd }} {{ destiny?.mm }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row px-2" *ngIf="destiny.items !== undefined">
              <div class="row" *ngFor="let item of destiny.items; let in = index">
                <div class="col-9">
                  <usb-item-hotel *ngIf="item?.categoryName === 'HOTELS'" [item]="item.item"></usb-item-hotel>

                  <usb-item-tours *ngIf="item?.categoryName == 'TOURS'" [item]="item.item"></usb-item-tours>

                  <usb-item-transports *ngIf="item?.categoryName == 'TRANSPORTS'" [item]="item.item"></usb-item-transports>
                </div>
                <div class="col-3 state-pax-multi">
                  <div class="row pt-2">
                    <ul *ngIf="item.item.status_id === 1 || item.item.status_id === 2" class="nav">
                      <li class="item-nav">
                        <a class="item-button" (click)="removeItem(item, in, i)" title="delete">
                          <i class="icon-delete icon" aria-hidden="true">&nbsp;&nbsp;</i>
                        </a>
                      </li>
                      <li class="item-nav" *ngIf="item?.product !== undefined && item?.product !== null">
                        <!-- <div class="item-button px-1" title="edit" (click)="modalRoom.show()">
                          <i class="icon-edit icon icon-pencil p-1" style="background-color: #272727;" aria-hidden="true"></i>
                        </div>
                        <div>
                          <usb-modals bsModal #modalRoom="bs-modal" class="modal fade" tabindex="-1" role="dialog"
                            aria-hidden="true" [modalRoomRef]="modalRoom" [product]="item.product" [productQty]="1"
                            [form]="activeItineraryForm" [payloadUpdate]="item.payloadUpdate" [view_info]="false"
                            [itineraryItem]="item.item" [origin]="origin">
                          </usb-modals>
                        </div> -->
                      </li>
                      <li class="item-nav" *ngIf="item?.product !== undefined && item?.product !== null">
                        <!-- <a class="item-button" title="info" (click)="modalRoom.show()">
                          <i class="icon-info icon" aria-hidden="true">&nbsp;&nbsp;</i>
                        </a>
                        <div>
                          <usb-modals bsModal #modalRoom="bs-modal" class="modal fade" tabindex="-1" role="dialog"
                            aria-hidden="true" [modalRoomRef]="modalRoom" [product]="item.product" [productQty]="1"
                            [form]="activeItineraryForm" [payloadUpdate]="item.payloadUpdate" [view_info]="true"
                            [itineraryItem]="item.item" [origin]="origin"></usb-modals>
                        </div> -->
                      </li>
                    </ul>
                    <div class="col-12 pt-4">
                      <span
                        *ngIf="item.item.status_id === 1"
                        class="status product-status-saved"
                        style="margin-left: -10px !important; border: none !important"
                        >{{ item.item.status }}</span
                      >
                      <span
                        *ngIf="item.item.status_id === 2"
                        class="status product-status-reserved"
                        style="margin-left: -10px !important"
                        >{{ item.item.status }}</span
                      >
                      <span *ngIf="item.item.status_id === 3" class="status product-status-locked" style="margin-left: -10px !important">{{
                        item.item.status
                      }}</span>
                      <span *ngIf="item.item.status_id === 4" class="status product-status-denied" style="margin-left: -10px !important">{{
                        item.item.status
                      }}</span>
                      <span
                        *ngIf="item.item.status_id === 5"
                        class="status product-status-cancelled"
                        style="margin-left: -10px !important"
                        >{{ item.item.status }}</span
                      >
                      <span *ngIf="item.item.status_id === 6" class="status product-status-paid-agency">{{ item.item.status }}</span>
                      <span *ngIf="item.item.status_id === 7" class="status product-status-paid-provider">{{ item.item.status }}</span>
                      <span *ngIf="item.item.status_id === 8" class="status product-status-completed">{{ item.item.status }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <i
                *ngIf="multidestination[i - 1]?.city.length !== '' && i + 1 < multidestination?.length"
                class="icon-separadores d-flex align-items-end text-white"
                aria-hidden="true"
              ></i>
            </div>
          </div>
        </div>
      </div>

      <hr class="divider-items" />
      <div
        class="ml-auto my-3 d-flex align-items-end justify-content-end"
        id="continue-itinerary-s"
        [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_3 }"
      >
        <button type="button" class="btn btn-block btn-big btn-usblick rounded-pill text-uppercase" (click)="changeTab()">CONTINUE</button>
      </div>
    </div>

    <div *ngIf="modeView == 'MULTIDESTINATION'">
      <usb-multi-destination [payload]="payload"></usb-multi-destination>
    </div>
  </div>

  <div [ngClass]="{'mb-5': !buttonDisabled}" *ngIf="modeView == 'RESULT' && origin !== 'MULTIDESTINATION'">
    <usb-summary-footer
      [modeView]="modeView"
      [buttonDisabled]="buttonDisabled"
      [_actualItinerary]="_actualItinerary"
      [payload]="payload"
      (openModalForTransport)="openModalForTransport()"
    ></usb-summary-footer>
  </div>
</div>
